"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _mobxReact = require("mobx-react");
var _autobindDecorator = _interopRequireDefault(require("autobind-decorator"));
var _mobx = require("mobx");
var _state = require("@seedlang/state");
var _constants = require("@seedlang/constants");
var _utils = require("@seedlang/utils");
var _lodash = require("lodash");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
var WordOptionsCardWrapper = function WordOptionsCardWrapper(Component) {
  var _class, _class2, _descriptor, _descriptor2, _descriptor3;
  return (0, _mobxReact.observer)(_class = (_class2 = /*#__PURE__*/function (_React$Component) {
    function _class2(props) {
      var _this;
      _classCallCheck(this, _class2);
      _this = _callSuper(this, _class2, [props]);
      _initializerDefineProperty(_this, "multipleChoiceSelected", _descriptor, _this);
      _initializerDefineProperty(_this, "correct", _descriptor2, _this);
      _initializerDefineProperty(_this, "incorrectAnswer", _descriptor3, _this);
      _state.DeckUI.enrichWord(_this.props.card);
      return _this;
    }
    _inherits(_class2, _React$Component);
    return _createClass(_class2, [{
      key: "icons",
      get: function get() {
        var ary = [];
        if ((0, _utils.isPresent)(this.props.card.grammarTip)) {
          ary.push('grammarTip');
        }
        if (_state.DeckUI.reviewDeck && this.props.cardState.revealed) {
          ary.push('reviewDetails');
        }
        if (!_state.DeckUI.reviewDeck && this.props.cardState.revealed) {
          ary.push('toggleReview');
        }
        if (this.props.cardState.revealed) {
          ary.push('cardComments');
        }
        if (this.props.cardState.revealed) {
          ary.push('vocabCard');
        }
        if (_state.DeckUI.reviewDeck && (this.props.cardState.revealed || this.props.card.showNoteBeforeReveal)) {
          ary.push('cardNote');
        }
        if (!this.props.cardState.revealed && this.props.card.cardType.slug === 'number_options' && !(0, _utils.isBlank)(this.props.card.word.digitSourceText)) {
          ary.push('toggleMultipleChoice');
        }
        return ary;
      }
    }, {
      key: "showExpandedTarget",
      get: function get() {
        return !_state.DeckUI.user.hideVocabTargetUntilRevealed || !this.props.card.hasTargetVideoClip || this.props.cardState.revealed;
      }
    }, {
      key: "sectionHeight",
      get: function get() {
        if (this.props.cardState.revealed) {
          if (this.props.card.hasTargetVideoClip) {
            return _state.DeckUI.layout.heightForCardSections(3);
          }
          return _state.DeckUI.layout.heightForCardSections(2);
        } else if (this.props.card.hasTargetVideoClip) {
          return _state.DeckUI.layout.contentHeightWithMultipleChoiceButtons(4) / 2;
        } else {
          return _state.DeckUI.layout.contentHeightWithMultipleChoiceButtons(4);
        }
      }
    }, {
      key: "correctSourceText",
      get: function get() {
        var _this$props$card,
          _this2 = this;
        if ((0, _utils.isPresent)((_this$props$card = this.props.card) === null || _this$props$card === void 0 || (_this$props$card = _this$props$card.word) === null || _this$props$card === void 0 ? void 0 : _this$props$card.falseMultipleChoiceOptions)) {
          var sourceInNativeLanguage = this.props.card.word.translationSources.find(function (ts) {
            var _this2$props$card;
            return ts.source.languageId === ((_this2$props$card = _this2.props.card) === null || _this2$props$card === void 0 || (_this2$props$card = _this2$props$card.word) === null || _this2$props$card === void 0 ? void 0 : _this2$props$card.falseMultipleChoiceOptionsLanguageId) && ts.accepted && !ts.rejected;
          });
          if ((0, _utils.isPresent)(sourceInNativeLanguage)) {
            return sourceInNativeLanguage.source.text;
          } else {
            return this.props.card.word.firstVocabSourceForUser(_state.AppUI.user);
          }
        }
        return this.props.card.source || this.props.card.word.vocabEnSourceListForUser(_state.AppUI.user)[0];
      }
    }, {
      key: "falseMultipleChoiceOptions",
      get: function get() {
        var _this$props$card2,
          _this$props$card4,
          _this$props$card5,
          _this$props$card6,
          _this3 = this;
        var sourceList;
        if ((0, _utils.isPresent)((_this$props$card2 = this.props.card) === null || _this$props$card2 === void 0 || (_this$props$card2 = _this$props$card2.word) === null || _this$props$card2 === void 0 ? void 0 : _this$props$card2.falseMultipleChoiceOptions)) {
          var _this$props$card3;
          sourceList = (_this$props$card3 = this.props.card) === null || _this$props$card3 === void 0 || (_this$props$card3 = _this$props$card3.word) === null || _this$props$card3 === void 0 ? void 0 : _this$props$card3.falseMultipleChoiceOptions.split(',');
        } else if ((_this$props$card4 = this.props.card) !== null && _this$props$card4 !== void 0 && (_this$props$card4 = _this$props$card4.word) !== null && _this$props$card4 !== void 0 && (_this$props$card4 = _this$props$card4.wordType) !== null && _this$props$card4 !== void 0 && _this$props$card4.abbreviation && (_this$props$card5 = this.props.card) !== null && _this$props$card5 !== void 0 && (_this$props$card5 = _this$props$card5.word) !== null && _this$props$card5 !== void 0 && (_this$props$card5 = _this$props$card5.level) !== null && _this$props$card5 !== void 0 && _this$props$card5.abbreviation && (0, _lodash.keys)(_constants.SourceList).includes((_this$props$card6 = this.props.card) === null || _this$props$card6 === void 0 || (_this$props$card6 = _this$props$card6.word) === null || _this$props$card6 === void 0 || (_this$props$card6 = _this$props$card6.wordType) === null || _this$props$card6 === void 0 ? void 0 : _this$props$card6.abbreviation)) {
          sourceList = _constants.SourceList[this.props.card.word.wordType.abbreviation][this.props.card.word.level.abbreviation];
        }
        if (!sourceList) {
          sourceList = _constants.SourceList['noun']['A1'];
        }
        return (0, _lodash.shuffle)(sourceList.filter(function (item) {
          return !_this3.props.card.word.vocabSourcesWithoutGenderAbbreviation.includes(item);
        }));
      }
    }, {
      key: "vocabMultipleChoiceOptions",
      get: function get() {
        if (this.props.card && this.props.card.word && (0, _utils.isPresent)(this.props.card.word.vocabSourcesWithoutGenderAbbreviation) && !(0, _utils.isPresent)(this.props.card.vocabMultipleChoiceOptions)) {
          var correct, sources;
          if ((0, _utils.isPresent)(this.props.numberMultipleChoiceSources)) {
            correct = {
              id: 1,
              text: this.props.card.word.formattedDigitSourceText,
              correct: true
            };
            sources = this.props.numberMultipleChoiceSources;
          } else if (this.props.card.minimalPairCard) {
            var _this$props$card$word;
            correct = {
              id: 1,
              text: this.props.card.word.targetText,
              correct: true
            };
            sources = [(_this$props$card$word = this.props.card.word.minimalPair) === null || _this$props$card$word === void 0 ? void 0 : _this$props$card$word.targetText];
          } else {
            correct = {
              id: 1,
              text: this.correctSourceText,
              correct: true
            };
            sources = this.falseMultipleChoiceOptions;
          }
          var options = sources.map(function (source, index) {
            return {
              id: index + 2,
              text: source,
              correct: false
            };
          });
          var rand = (0, _lodash.random)(0, 3);
          options.splice(rand, 0, correct);
          this.props.card.set('vocabMultipleChoiceOptions', options.slice(0, 4));
        }
        return this.props.card.vocabMultipleChoiceOptions || [];
      }
    }, {
      key: "clearSelection",
      value: function clearSelection() {
        this.multipleChoiceSelected = null;
      }
    }, {
      key: "onClick",
      value: function onClick(option) {
        var _this4 = this;
        this.multipleChoiceSelected = option.id;
        this.props.cardState.selectedOptionText = option.text;
        if (option.correct) {
          this.correct = true;
          _state.DeckUI.onCorrectAnswer(this.props.card, this.props.cardState, this.props.userCard, {
            xp: 2,
            xpSlug: 'exercise',
            multipleChoiceOptionId: option.id
          });
        } else {
          this.incorrect = true;
          this.incorrectAnswer = option.text;
          _state.DeckUI.onIncorrectAnswer(this.props.card, this.props.cardState, this.props.userCard, option.id);
        }
        setTimeout(this.clearSelection, 500);
        setTimeout(function () {
          return _state.DeckUI.reveal(_this4.props.card, _this4.props.cardState);
        }, 500);
      }
    }, {
      key: "onNextClick",
      value: function onNextClick() {
        _state.DeckUI.advanceCard(this.props.card, this.props.cardState, this.props.userCard);
        this.incorrectAnswer = null;
      }
    }, {
      key: "render",
      value: function render() {
        return /*#__PURE__*/_react["default"].createElement(Component, _extends({}, this.props, {
          vocabMultipleChoiceOptions: this.vocabMultipleChoiceOptions,
          multipleChoiceSelected: this.multipleChoiceSelected,
          onClick: this.onClick,
          correct: this.correct,
          incorrectAnswer: this.incorrectAnswer,
          sectionHeight: this.sectionHeight,
          icons: this.icons,
          onNextClick: this.onNextClick,
          showExpandedTarget: this.showExpandedTarget
        }));
      }
    }]);
  }(_react["default"].Component), _descriptor = _applyDecoratedDescriptor(_class2.prototype, "multipleChoiceSelected", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "correct", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return false;
    }
  }), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, "incorrectAnswer", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return null;
    }
  }), _applyDecoratedDescriptor(_class2.prototype, "icons", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "icons"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "showExpandedTarget", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "showExpandedTarget"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "sectionHeight", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "sectionHeight"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "correctSourceText", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "correctSourceText"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "falseMultipleChoiceOptions", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "falseMultipleChoiceOptions"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "vocabMultipleChoiceOptions", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "vocabMultipleChoiceOptions"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "clearSelection", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "clearSelection"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "onClick", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "onClick"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "onNextClick", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "onNextClick"), _class2.prototype), _class2)) || _class;
};
WordOptionsCardWrapper.displayName = 'WordOptionsCardWrapper';
var _default = exports["default"] = WordOptionsCardWrapper;